import { useTranslation } from 'react-i18next';
const I18N = ({ children, parameters }) => {
    const { i18n, ready, t } = useTranslation();
    return ready && i18n.exists(children) ? t(children, parameters) : children;
};
export default I18N;
